import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c940fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "vbs-modal" }
const _hoisted_2 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center flex-column confirm-message" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = {
  key: 1,
  class: "modal-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, [
      _createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "custom-classes",
        "enter-active-class": "bs-dialog-animated dialog-fadeInDown",
        "leave-active-class": "bs-dialog-animated dialog-fadeOutUp"
      }, {
        default: _withCtx(() => [
          (!_ctx.out)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["modal", _ctx.getDialogContainerClass()]),
                tabindex: "-1",
                "aria-modal": "true",
                role: "dialog",
                onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setInitialTarget($event)), ["left"])),
                onMouseup: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onBackdropClick($event)), ["left"]))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["modal-dialog", _ctx.getDialogClass()])
                }, [
                  (!_ctx.full)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
                          (_ctx.displayCloseBtn)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn-close",
                                "aria-label": "Close",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseBtnClick && _ctx.onCloseBtnClick(...args)))
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.icon)
                            }, null, 2),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.message), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                          }, _toDisplayString(_ctx.leftBtnText), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
                          }, _toDisplayString(_ctx.rightBtnText), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.full)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.content), _mergeProps(_ctx.contentProps, _toHandlers(_ctx.contentEmits)), null, 16))
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 34))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "custom-classes",
        "enter-active-class": "bs-dialog-animated dialog-fadeIn",
        "leave-active-class": "bs-dialog-animated dialog-fadeOut"
      }, {
        default: _withCtx(() => [
          (!_ctx.out)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["modal-backdrop", _ctx.getDialogBackdropClass()])
              }, null, 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}